import React from 'react';

// Lightweight stroke icon set — 1.5px stroke, currentColor.
// Usage: <Icon name="cart" size={20} />
export const Icon = ({ name, size = 20, className = '', style }) => {
  const props = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    className,
    style,
    'aria-hidden': true,
  };
  switch (name) {
    case 'search':
      return (
        <svg {...props}>
          <circle cx="11" cy="11" r="7" />
          <path d="m20 20-3.5-3.5" />
        </svg>
      );
    case 'cart':
      return (
        <svg {...props}>
          <path d="M3 4h2l2.4 12.3a2 2 0 0 0 2 1.7h8.2a2 2 0 0 0 2-1.6L21 8H6" />
          <circle cx="10" cy="20" r="1.4" />
          <circle cx="18" cy="20" r="1.4" />
        </svg>
      );
    case 'user':
      return (
        <svg {...props}>
          <circle cx="12" cy="8" r="4" />
          <path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" />
        </svg>
      );
    case 'globe':
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12h18M12 3c3 3.5 3 14 0 18M12 3c-3 3.5-3 14 0 18" />
        </svg>
      );
    case 'sun':
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </svg>
      );
    case 'moon':
      return (
        <svg {...props}>
          <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" />
        </svg>
      );
    case 'menu':
      return (
        <svg {...props}>
          <path d="M4 7h16M4 12h16M4 17h16" />
        </svg>
      );
    case 'close':
      return (
        <svg {...props}>
          <path d="M6 6l12 12M18 6 6 18" />
        </svg>
      );
    case 'bolt':
      return (
        <svg {...props}>
          <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z" />
        </svg>
      );
    case 'shield':
      return (
        <svg {...props}>
          <path d="M12 3 4 6v6c0 5 3.5 8.5 8 9 4.5-.5 8-4 8-9V6l-8-3Z" />
          <path d="m9 12 2 2 4-4" />
        </svg>
      );
    case 'discount':
      return (
        <svg {...props}>
          <path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z" />
          <circle cx="8" cy="8" r="1.5" />
        </svg>
      );
    case 'support':
      return (
        <svg {...props}>
          <path d="M4 13a8 8 0 0 1 16 0v3a3 3 0 0 1-3 3h-1v-7h4M4 13v3a3 3 0 0 0 3 3h1v-7H4" />
        </svg>
      );
    case 'crypto':
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="9" />
          <path d="M9 7v10M14 8h-3a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4H9" />
        </svg>
      );
    case 'chat':
      return (
        <svg {...props}>
          <path d="M21 12a8 8 0 0 1-12.4 6.7L4 20l1.4-4.4A8 8 0 1 1 21 12Z" />
        </svg>
      );
    case 'arrowRight':
      return (
        <svg {...props}>
          <path d="M5 12h14M13 5l7 7-7 7" />
        </svg>
      );
    case 'arrowLeft':
      return (
        <svg {...props}>
          <path d="M19 12H5M11 5l-7 7 7 7" />
        </svg>
      );
    case 'check':
      return (
        <svg {...props}>
          <path d="m4 12 5 5L20 6" />
        </svg>
      );
    case 'star':
      return (
        <svg {...props} fill="currentColor" stroke="none">
          <path d="m12 2 3 7 7 1-5 5 1 7-6-3.5L6 22l1-7-5-5 7-1Z" />
        </svg>
      );
    case 'starOutline':
      return (
        <svg {...props}>
          <path d="m12 2 3 7 7 1-5 5 1 7-6-3.5L6 22l1-7-5-5 7-1Z" />
        </svg>
      );
    case 'heart':
      return (
        <svg {...props}>
          <path d="M12 21s-7-4.5-9.5-9A5 5 0 0 1 12 6a5 5 0 0 1 9.5 6c-2.5 4.5-9.5 9-9.5 9Z" />
        </svg>
      );
    case 'heartFilled':
      return (
        <svg {...props} fill="currentColor" stroke="none">
          <path d="M12 21s-7-4.5-9.5-9A5 5 0 0 1 12 6a5 5 0 0 1 9.5 6c-2.5 4.5-9.5 9-9.5 9Z" />
        </svg>
      );
    case 'gem':
      return (
        <svg {...props}>
          <path d="M6 3h12l3 6-9 12L3 9Z" />
          <path d="M3 9h18M9 9 12 3l3 6-3 12-3-12Z" />
        </svg>
      );
    case 'phone':
      return (
        <svg {...props}>
          <rect x="6" y="2" width="12" height="20" rx="3" />
          <path d="M11 18h2" />
        </svg>
      );
    case 'pc':
      return (
        <svg {...props}>
          <rect x="2" y="4" width="20" height="13" rx="2" />
          <path d="M9 21h6M12 17v4" />
        </svg>
      );
    case 'console':
      return (
        <svg {...props}>
          <rect x="2" y="7" width="20" height="11" rx="5" />
          <path d="M8 12h3M9.5 10.5v3M15 11h.01M17 13h.01" />
        </svg>
      );
    case 'sub':
      return (
        <svg {...props}>
          <path d="M4 5h16v14H4z" />
          <path d="m10 9 5 3-5 3V9Z" />
        </svg>
      );
    case 'gift':
      return (
        <svg {...props}>
          <rect x="3" y="8" width="18" height="13" rx="2" />
          <path d="M3 12h18M12 8v13" />
          <path d="M12 8c-2 0-4-1-4-3s2-2 3-1 1 4 1 4-2-1-3-1-3 0-3-2 2-3 3-2 3 5 3 5Z" />
        </svg>
      );
    case 'sparkle':
      return (
        <svg {...props}>
          <path d="M12 2v6M12 16v6M2 12h6M16 12h6M5 5l3 3M16 16l3 3M5 19l3-3M16 8l3-3" />
        </svg>
      );
    case 'fire':
      return (
        <svg {...props}>
          <path d="M12 3s4 3 4 8-2 6-4 6-4-1-4-4 2-5 2-5-3-1-3-4 5-1 5-1Z" />
        </svg>
      );
    case 'crown':
      return (
        <svg {...props}>
          <path d="M3 7l3 11h12l3-11-5 4-4-7-4 7-5-4Z" />
        </svg>
      );
    case 'card':
      return (
        <svg {...props}>
          <rect x="2" y="5" width="20" height="14" rx="2" />
          <path d="M2 10h20M6 15h4" />
        </svg>
      );
    case 'box':
      return (
        <svg {...props}>
          <path d="M21 8v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8" />
          <path d="M1 5h22v3H1zM10 12h4" />
        </svg>
      );
    case 'mail':
      return (
        <svg {...props}>
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="m3 7 9 7 9-7" />
        </svg>
      );
    case 'plus':
      return (
        <svg {...props}>
          <path d="M12 5v14M5 12h14" />
        </svg>
      );
    case 'minus':
      return (
        <svg {...props}>
          <path d="M5 12h14" />
        </svg>
      );
    case 'play':
      return (
        <svg {...props} fill="currentColor" stroke="none">
          <path d="M8 5v14l11-7L8 5Z" />
        </svg>
      );
    case 'trash':
      return (
        <svg {...props}>
          <path d="M4 7h16M10 11v6M14 11v6M5 7l1 13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-13M9 7V4h6v3" />
        </svg>
      );
    case 'logout':
      return (
        <svg {...props}>
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
        </svg>
      );
    case 'clock':
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      );
    case 'lock':
      return (
        <svg {...props}>
          <rect x="4" y="10" width="16" height="11" rx="2" />
          <path d="M8 10V7a4 4 0 0 1 8 0v3" />
        </svg>
      );
    case 'apple':
      return (
        <svg viewBox="0 0 24 24" width={size} height={size} className={className} style={style} aria-hidden>
          <path fill="currentColor" d="M17.4 13.5c0-2.6 2.1-3.8 2.2-3.9-1.2-1.7-3-2-3.7-2-1.6-.2-3 .9-3.8.9-.8 0-2-.9-3.3-.9-1.7 0-3.3 1-4.2 2.5C2.8 13 4 17.6 5.8 20c.9 1.2 2 2.5 3.3 2.5 1.3-.1 1.8-.9 3.4-.9 1.6 0 2 .9 3.4.9 1.4 0 2.3-1.2 3.2-2.4.9-1.3 1.3-2.6 1.4-2.7-.1 0-2.6-1-2.6-3.9ZM14.5 4.8c.7-.9 1.2-2.1 1.1-3.3-1 0-2.3.7-3 1.5-.7.8-1.3 2-1.1 3.2 1.1.1 2.3-.5 3-1.4Z" />
        </svg>
      );
    case 'google':
      return (
        <svg viewBox="0 0 24 24" width={size} height={size} className={className} style={style} aria-hidden>
          <path fill="#4285F4" d="M21.6 12.2c0-.7-.1-1.4-.2-2H12v3.8h5.4c-.2 1.2-.9 2.3-2 3v2.5h3.3c1.9-1.8 3-4.4 3-7.3Z" />
          <path fill="#34A853" d="M12 22c2.7 0 5-.9 6.6-2.4l-3.3-2.5c-.9.6-2 1-3.3 1-2.6 0-4.7-1.7-5.5-4H3.2v2.5C4.8 19.7 8.2 22 12 22Z" />
          <path fill="#FBBC05" d="M6.5 14.1c-.2-.6-.3-1.3-.3-2s.1-1.4.3-2V7.5H3.2C2.4 9 2 10.4 2 12s.4 3 1.2 4.5l3.3-2.4Z" />
          <path fill="#EA4335" d="M12 5.6c1.5 0 2.8.5 3.8 1.5l2.8-2.8C17 2.7 14.7 1.7 12 1.7 8.2 1.7 4.8 4 3.2 7.5l3.3 2.5C7.3 7.3 9.4 5.6 12 5.6Z" />
        </svg>
      );
    case 'facebook':
      return (
        <svg viewBox="0 0 24 24" width={size} height={size} className={className} style={style} aria-hidden>
          <path fill="#1877F2" d="M22 12c0-5.5-4.5-10-10-10S2 6.5 2 12c0 5 3.7 9.1 8.4 9.9V15h-2.5v-3h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.3 0-1.7.8-1.7 1.6V12h2.9l-.5 3h-2.4v6.9C18.3 21.1 22 17 22 12Z" />
        </svg>
      );
    case 'line':
      return (
        <svg viewBox="0 0 24 24" width={size} height={size} className={className} style={style} aria-hidden>
          <path fill="#06C755" d="M12 2C6.5 2 2 5.7 2 10.3c0 4.1 3.6 7.5 8.5 8.1.3.1.8.2.9.5.1.3 0 .7 0 1l-.2.8c0 .2-.2 1 .8.5 1-.4 5.4-3.2 7.3-5.4 1.4-1.5 2-3.1 2-5.5C21.3 5.7 16.8 2 12 2Z" />
        </svg>
      );
    case 'x':
    case 'twitter':
      return (
        <svg viewBox="0 0 24 24" width={size} height={size} className={className} style={style} aria-hidden>
          <path fill="currentColor" d="M18.244 2H21l-6.524 7.453L22 22h-6.828l-5.36-7.013L3.5 22H.74l6.98-7.974L0 2h7l4.847 6.394L18.244 2Zm-1.19 18.16h1.886L7.06 3.77H5.04l12.014 16.39Z" />
        </svg>
      );
    case 'instagram':
      return (
        <svg viewBox="0 0 24 24" width={size} height={size} className={className} style={style} aria-hidden>
          <defs>
            <linearGradient id="ig-grad" x1="0%" y1="100%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#F58529" />
              <stop offset="50%" stopColor="#DD2A7B" />
              <stop offset="100%" stopColor="#8134AF" />
            </linearGradient>
          </defs>
          <rect x="3" y="3" width="18" height="18" rx="5" fill="url(#ig-grad)" />
          <circle cx="12" cy="12" r="4" fill="none" stroke="#fff" strokeWidth="1.8" />
          <circle cx="17.4" cy="6.6" r="1.1" fill="#fff" />
        </svg>
      );
    case 'youtube':
      return (
        <svg viewBox="0 0 24 24" width={size} height={size} className={className} style={style} aria-hidden>
          <path fill="#FF0000" d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2C0 8 0 12 0 12s0 4 .5 5.8a3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1c.5-1.8.5-5.8.5-5.8s0-4-.5-5.8Z" />
          <path fill="#fff" d="M9.6 15.6V8.4l6.2 3.6-6.2 3.6Z" />
        </svg>
      );
    default:
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="9" />
        </svg>
      );
  }
};

export default Icon;
